import LayerSwitcher from '@apps-common/ui-maps/LayerSwitcher';
import {array, func, object} from 'prop-types';
import React, {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {setBaseLayer, setOverlayOn} from '@actions/map';
import {DEFAULT_ZOOM, MAX_ZOOM} from '@app/constants';
import AdditionalZoomTools from '@components/Viewer/Map/AdditionalZoomTools';
import MapToolsGroup from '@components/Viewer/Map/MapToolsGroup';
import MeasureToolMenuButton from '@components/Viewer/Map/MeasureToolMenuButton';
import ZoomControls from '@components/Viewer/Map/ZoomControls';

const MapControls = ({
  measureFeatures,
  setHoverFeatures,
  setMeasureFeatures,
  setTempGeometry,
  tempGeometry,
  mapRef,
}) => {
  const dispatch = useDispatch();

  const selectedBackground = useSelector(state => state.map.baseLayer);
  const labelsOn = useSelector(state => state.map.overlays.labels);

  const zoomByDelta = delta => {
    const view = mapRef.getView();
    const currentZoom = view.getZoom();
    const newZoom = view.getConstrainedZoom(currentZoom + delta);
    const newResolution = view.getResolutionForZoom(newZoom);

    if (view.getAnimating()) {
      view.cancelAnimations();
    }
    view.animate({
      resolution: newResolution,
      duration: 250,
    });
  };

  const onHoverFeature = useCallback(
    feature => {
      if (feature) {
        setHoverFeatures([feature]);
      } else {
        setHoverFeatures([]);
      }
    },
    [setHoverFeatures]
  );

  return (
    <React.Fragment>
      <MapToolsGroup>
        <MeasureToolMenuButton
          tempGeometry={tempGeometry}
          setTempGeometry={setTempGeometry}
          features={measureFeatures}
          setFeatures={setMeasureFeatures}
          onHover={onHoverFeature}
        />
      </MapToolsGroup>

      <MapToolsGroup>
        <LayerSwitcher
          selectedBackground={selectedBackground}
          labelsOn={labelsOn}
          onBackgroundChange={value => dispatch(setBaseLayer(value))}
          onLabelsChange={() =>
            dispatch(setOverlayOn({name: 'labels', on: !labelsOn}))
          }
        />
      </MapToolsGroup>

      <MapToolsGroup>
        <ZoomControls
          maxZoom={MAX_ZOOM}
          minZoom={DEFAULT_ZOOM}
          additionalControls={
            <AdditionalZoomTools
              map={mapRef}
              placement="left-end"
              sx={{
                borderRadius: '0 0 4px 4px',
                boxShadow: 'none',
              }}
            />
          }
          onZoom={zoomByDelta}
        />
      </MapToolsGroup>
    </React.Fragment>
  );
};

MapControls.propTypes = {
  measureFeatures: array,
  setHoverFeatures: func,
  setMeasureFeatures: func,
  setTempGeometry: func,
  tempGeometry: object,
  mapRef: object,
};

export default MapControls;
